import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';
import { I18n, Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import CashFormatter from '../Common/cashFormatter';
import axios from 'axios';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle, isVAK } from '../../actions/root_url';

const { Selectors } = Data;

export class SplitSOModal extends Component {
    constructor() {
        super();
        this.state = {
            rows: [],
            customers: [],
            selectedCustomer: '',
            shippingAddresses: [],
            shippingAddress: '',
        }
    }

    componentDidMount() {
        if (isVAK) {
            if ((this.props.selectedCompany || { value: '' }).value) {
                this.props.fetchActiveCustomers(this.props.selectedCompany.value)
            }
        }
        if (this.props.soDetail && isVAK) {
            let rows = this.props.soDetail.rows.map(item => {
                return { ...item, SplitQty: 0, SplitUnitPrice: item.UnitPrice };
            })
            this.setState({
                rows,
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.soDetail != this.props.soDetail) {
            let rows = nextProps.soDetail.rows.map(item => {
                return { ...item, SplitQty: 0, SplitUnitPrice: item.UnitPrice };
            })
            this.setState({
                rows,
            })
        }
        if (nextProps.customers && isVAK) {
            if (nextProps.customers.length > 1) {
                let customers = nextProps.customers.map(item => { return { label: item.Name, value: item.Customer_id } })
                this.setState({
                    customers,
                })
            }
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.selectedCustomer !== prevState.selectedCustomer && this.state.selectedCustomer) {
            this.setState({ shippingAddresses: [], shippingAddress: '' });
            this.fetchShippingAddressesAPI(this.state.selectedCustomer.value, (data) => {

                const shippingAddresses = data.map(shipping => ({ label: shipping.AddressName, value: shipping.CustomerDetail_id, isDefault: shipping.IsDefault }));
                const defaultShipping = shippingAddresses.filter(shipping => shipping.IsDefault);
                this.setState({
                    shippingAddresses,
                    shippingAddress: defaultShipping[0] || shippingAddresses[0].value
                });
            })
        }
        if (prevProps.customers && this.state.customers.length == 0 && isVAK) {
            let customers = prevProps.customers.map(item => { return { label: item.Name, value: item.Customer_id } })
            this.setState({
                customers,
            })
        }
    }

    fetchShippingAddressesAPI = (customerid, success) => {
        axios({
            method: 'GET',
            url: `${ROOT_URL}v1/sale/customer/${customerid}`,
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
            .then(res => {
                success(res.data.Shipping)
            }).catch(e => {
                if (e.error) {
                    alert(JSON.stringify(e.error));
                }
            })
    }
    splitSOAPI = (data, soId, success) => {
        axios({
            method: 'POST',
            url: `${ROOT_URL}v1/sale/split_sales_order/${soId}`,
            data,
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
            .then(res => {
                success()
            }).catch(e => {
                if (e.data) {
                    alert(JSON.stringify(e.data));
                }
            })
    }

    handleSplitSo = () => {
        const filteredRows = _.filter(this.state.rows, row => row.SplitQty && row.SplitUnitPrice);
        const split_sales_order_lines = _.map(filteredRows, row => ({
            order_line_id: row.SalesOrderLine_id,
            split_qty: row.SplitQty,
            split_unit_price: row.SplitUnitPrice,
        }));
        if (!this.state.selectedCustomer || !(this.state.selectedCustomer || { value: '' }.value)) {
            alert('Customer can not empty!');
            return
        }
        if (!this.state.shippingAddress || !(this.state.shippingAddress || { value: '' }.value)) {
            alert('Shipping Address can not empty!');
            return
        }
        if (split_sales_order_lines.length == 0) {
            alert('There are no orders to be split!');
            return
        }
        let isAllSplit = split_sales_order_lines.length == this.state.rows.length && !this.state.rows.some((item) => item.SplitQty != item.Quantity);
        if (isAllSplit) {
            alert('Cannot split all products!');
            return
        }
        let data = {
            split_customer_shipping_id: (this.state.shippingAddress || { value: '' }).value || this.state.shippingAddress,
            split_customer_id: (this.state.selectedCustomer || { value: '' }).value || this.state.selectedCustomer,
            split_sales_order_lines,
        }
        this.splitSOAPI(data, this.props.soId, () => {
            alert('Split Success!');
            this.props.onConfirm();
        });
    }

    renderCustomer() {
        // if (this.props.usersIsLoading) return <WidgetsSpinner />; 
        return (
            <Select
                className='testSelect'
                value={this.state.selectedCustomer}
                onChange={(event) => {
                    this.setState({ selectedCustomer: event })
                }}
                placeholder={I18n.t('customer')}
                options={this.state.customers}
            />
        );
    }

    renderShipAddress() {
        // if (this.props.usersIsLoading) return <WidgetsSpinner />; 
        return (
            <Select
                className='testSelect'
                value={this.state.shippingAddress}
                onChange={(event) => {
                    this.setState({ shippingAddress: event })
                }}
                placeholder={I18n.t('shipping_address')}
                options={this.state.shippingAddresses}
            />
        );
    }

    renderSoLineTable() {
        const getRows = () => {
            return Selectors.getRows(this.state);
        }
        const getSize = () => {
            return getRows().length;
        }
        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }

        const columns = [
            {
                key: 'ProductNum',
                name: <Translate value="product_num" />,
                resizable: true,
                sortable: true,
                filterable: true,
            },
            {
                key: "RefNum",
                name: <Translate value={"sku"} />,
                resizable: true,
                sortable: true,
            },
            {
                key: 'Description',
                name: <Translate value="description" />,
                resizable: true,
                sortable: true,
                filterable: true,
            },
            {
                key: 'Quantity',
                name: <Translate value="qty" />,
                resizable: true,
                sortable: true,
                filterable: true,
            },
            {
                key: "PickupQuantity",
                name: <Translate value="shipped_qty" />,
                resizable: true,
                sortable: true,
            },
            {
                key: "UnitPrice",
                name: <Translate value="unit_dollarsign" />,
                resizable: true,
                sortable: true,
                formatter: CashFormatter,
            },
            {
                key: "SplitQty",
                name: <Translate value="split_qty" />,
                resizable: true,
                sortable: true,
                editable: true,
            },
            {
                key: "SplitUnitPrice",
                name: <Translate value="split_unit_price" />,
                resizable: true,
                sortable: true,
                editable: true,
                width: 160,
                formatter: ({ value }) => {
                    return <div>{value ? `$${value}` : ''}</div>
                },
            },
        ];

        const handleRowUpdated = (e) => {
            const rows = getRows();
            if (e.updated.SplitQty != null) {
                let splitQty = 0;
                if (e.updated.SplitQty && !isNaN(e.updated.SplitQty)) {
                    splitQty = parseFloat(e.updated.SplitQty);
                }
                if (splitQty < 0) {
                    alert("Quantity is not allowed to be negative");
                    return;
                }
                if (splitQty > Number(rows[e.rowIdx].Quantity)) {
                    if (rows.length == 1) {
                        if (rows[0].Quantity == 1) {
                            alert("The order cannot be split");
                            splitQty = 0;
                        } else {
                            splitQty = Number(rows[e.rowIdx].Quantity) - 1;
                        }
                    } else {
                        splitQty = Number(rows[e.rowIdx].Quantity);
                    }
                }
                Object.assign(rows[e.rowIdx], { SplitQty: splitQty });
            }

            if (e.updated.SplitUnitPrice != null) {
                let unitPrice = rows[e.rowIdx].UnitPrice;
                if (e.updated.SplitUnitPrice && !isNaN(e.updated.SplitUnitPrice)) {
                    unitPrice = parseFloat(e.updated.SplitUnitPrice);
                }
                if (parseFloat(e.updated.SplitUnitPrice) < 0) {
                    alert("Split Unit Price is not allowed to be negative");
                    return;
                }
                Object.assign(rows[e.rowIdx], { SplitUnitPrice: unitPrice });
            }
        };

        return (
            <ReactDataGrid
                enableCellSelect={true}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={150}
                rowHeight={35}
                onRowUpdated={handleRowUpdated}
            />
        )
    }

    render() {
        return (
            <div>
                <div style={{ display: 'flex', width: '100%', flexDirection: 'row', alignItems: 'center' }}>
                    <div style={{ width: '50%' }}>
                        {this.renderCustomer()}
                    </div>
                    <div style={{ width: '50%' }}>
                        {this.renderShipAddress()}
                    </div>
                </div>
                <div style={{ marginTop: '10px' }}>
                    {this.renderSoLineTable()}
                </div>
                <div style={{ marginTop: '10px' }}>
                    <Button
                        bsStyle="primary"
                        onClick={this.handleSplitSo}
                        type="button"
                    >
                        <Translate value="split" />
                    </Button>
                </div>
            </div>
        );
    }
}

export default SplitSOModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/splitSOModal.jsx